import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";


// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class ColumnChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() { //console.log(this.props.data);
        var categoryCount = (this.props.data || []).length;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        var graphs = [];
        this.props.y_axis.map(function (pl, index) {
            graphs.push({
                "balloonText": "<b>[[category]]: [[value]]</b>",
                //"fillColorsField": "color",
                "fillColors":['#2196f3'],
                "fillAlphas": 0.9,
                "lineAlpha": 0.2,
                "type": "column",
                "valueField":  pl,
            });
        })
        const config = {
            "type": "serial",
            // Relative width so columns shrink to fit the card instead of overlapping
            "columnWidth": 0.7,
            "theme": "none",
            "marginTop": 5,
            "marginRight": 70,
            "dataProvider": this.props.data,
            "gridAboveGraphs": true,
            "startDuration": 1,
            "graphs":graphs,
            "chartCursor": {
                "categoryBalloonEnabled": false,
                "cursorAlpha": 0,
                "zoomable": true
            },
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                "gridPosition": "start",
                // Label every category (e.g. every date) instead of amCharts' auto-skipped subset
                "autoGridCount": false,
                "gridCount": categoryCount,
                "labelRotation": categoryCount > 12 ? 90 : 25,
                "fontSize":8
            },
            //"colors": "#000000",
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            }
        };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
}
export default ColumnChart;